/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usersettings_Description1Inputs */

const zh_usersettings_description1 = /** @type {(inputs: Usersettings_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理您的个人信息、绑定身份和密码设置。`)
};

const en_usersettings_description1 = /** @type {(inputs: Usersettings_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage your personal information, linked identities, and password settings.`)
};

const es_usersettings_description1 = /** @type {(inputs: Usersettings_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestiona tu información personal, identidades vinculadas y configuración de contraseña.`)
};

/**
* | output |
* | --- |
* | "Manage your personal information, linked identities, and password settings." |
*
* @param {Usersettings_Description1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const usersettings_description1 = /** @type {((inputs?: Usersettings_Description1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usersettings_Description1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_usersettings_description1(inputs)
	if (locale === "en") return en_usersettings_description1(inputs)
	return es_usersettings_description1(inputs)
});
export { usersettings_description1 as "userSettings_description" }